/**
 * 임의의 값을 Date 인스턴스로 정규화합니다.
 *
 * react-calendar 는 `value` 만 내부에서 Date 로 변환해 주고
 * `minDate` / `maxDate` 는 변환 없이 @wojtekmaj/date-utils 로 넘긴다.
 * 그 유틸은 Date 인스턴스가 아니면 `Failed to get month from date: ...` 예외를
 * 렌더 도중 던지고, 이 예외가 트리 전체를 언마운트시켜 화면이 하얗게 된다.
 *
 * API 응답의 날짜는 JSON 직렬화 때문에 항상 ISO 문자열이므로,
 * 달력에 넘기기 전 이 함수로 경계에서 정규화한다.
 *
 * 변환할 수 없는 값은 예외 대신 undefined 로 떨어뜨려
 * "제한 없음" 으로 안전하게 동작하게 한다.
 *
 * @param value - Date, ISO 문자열, epoch 숫자 또는 그 외 임의의 값
 * @returns 유효한 Date 인스턴스, 변환 불가 시 undefined
 * @public
 */
export const toDateOrUndefined = (value: unknown): Date | undefined => {
  if (value === null || value === undefined || value === '') return undefined;

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? undefined : value;
  }

  if (typeof value === 'string' || typeof value === 'number') {
    const parsed = new Date(value);
    return Number.isNaN(parsed.getTime()) ? undefined : parsed;
  }

  return undefined;
};
